import * as React from 'react';

interface IProps {
  className?: string;
}

export const Ensuranse: React.FC<IProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
      className={className}
    >
      <path
        fill="#0468FF"
        fillOpacity="0.1"
        d="M62.74 16.728c-25.259 0-29.533-7.992-29.57-8.067-.186-.39-.644-.652-1.162-.661h-.022c-.501 0-.965.261-1.166.643-.03.084-4.396 8.085-29.56 8.085-.704 0-1.26.475-1.26 1.047v35.812C0 64.942 32 80 32 80s32-15.057 32-26.413V17.775c-.005-.572-.564-1.047-1.26-1.047z"
      />
      <path
        fill="#0468FF"
        fillRule="evenodd"
        d="M44 36h-4v8H24v36h56V44H64v-8H44zm16 8v-4H44v4h16z"
        clipRule="evenodd"
      />
      <path fill="#fff" fillRule="evenodd" d="M56 56h-8v4H24v2h24v4h8v-4h24v-2H56v-4z" clipRule="evenodd" />
    </svg>
  );
};
